import styled from 'styled-components';

export const ActivityImageContainer = styled.div`
  background-image: ${(props) => `url( ${props.imagePath} )`};
  width: 100%;
  max-width: 100%;
  min-height: 200;
  padding: 0 0 56.25% 0;
  border-radius: 0;
  overflow: hidden;
  background-position: center;
  background-size: cover;
  position: relative;
  display: flex;
  margin: 1rem 0;
  border-radius: ${(props) => (props.xs ? null : '8px')};
`;

export const DomPurifyContentContainer = styled.div`
  width: 100%;
  line-height: 2rem;
  font-size: 1.15rem;
  text-align: none !important;
  margin: 0.3rem 0;

  > p {
    font-size: 1rem;
  }

  > ul,
  ol {
    padding-left: 3rem;
    font-size: 1rem;
  }
`;

export const GeneralTitle = styled.h1`
  font-family: 'Lato';
  font-size: ${(props) => (props.xs || props.sm ? '1.5rem' : '2rem')};
  font-weight: 700;
  line-height: ${(props) =>
    props.isPreview ? '2.5rem' : props.xs || props.sm ? '1.7rem' : '2.5rem'};
  /* margin: 0 0 .5rem 0; */
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : '.5rem')};
  color: #525252;
`;

export const FuelInputContainer = styled.div`
  position: relative;
`;

export const FuelInputLabel = styled.div`
  position: absolute;
  top: -8px;
  left: 12px;
  background-color: white;
  padding: 0 4px;
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
  z-index: 1;
`;

export const FuelInputField = styled.input`
  width: 100%;
  padding: 8.5px 40px 8.5px 14px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  outline: none;
  transition: border-color 0.2s;
  background-color: transparent;

  &:focus {
    border-color: #1976d2 !important;
    border-width: 2px !important;
  }

  &:not(:focus) {
    border-color: rgba(0, 0, 0, 0.23) !important;
    border-width: 1px !important;
  }

  &::placeholder {
    color: rgba(0, 0, 0, 0.4);
  }
`;

export const FuelInputSuffix = styled.div`
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(0, 0, 0, 0.6);
  pointer-events: none;
  font-size: 14px;
`;

// Estilos para ShareModal
export const SharePreviewContainer = styled.div`
  min-height: 400px;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 24px;
`;

export const ShareProgressBar = styled.div`
  height: 4px;
  background-color: #00bcd4;
  border-radius: 2px;
  margin-bottom: 24px;
`;

export const ShareLogo = styled.div`
  text-align: center;
  margin-bottom: 24px;

  h6 {
    color: #00bcd4;
    font-weight: bold;
    margin: 0;
  }
`;

export const ShareActivityImage = styled.div`
  height: 200px;
  background: linear-gradient(45deg, #00bcd4, #e91e63);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  position: relative;
  overflow: hidden;
`;

export const ShareActivityTitle = styled.h4`
  color: white;
  font-weight: bold;
  text-align: center;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  margin: 0;
  font-size: 2rem;
`;

export const ShareLogoCorner = styled.div`
  position: absolute;
  bottom: 8px;
  right: 8px;
  display: flex;
  gap: 8px;

  span {
    color: white;
    font-size: 12px;
  }
`;

export const ShareButton = styled.div`
  display: inline-block;
  background-color: #ff5722;
  color: white;
  padding: 12px 32px;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
`;

export const ShareLink = styled.div`
  text-align: center;
  font-size: 0.8rem;
  color: #1976d2;
  text-decoration: underline;
`;

export const ShareFooter = styled.div`
  text-align: center;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;

  h6 {
    color: #00bcd4;
    font-weight: bold;
    margin-bottom: 8px;
  }

  p {
    font-size: 0.75rem;
    color: #666;
    margin: 0;
  }
`;

export const ShareSwitchContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const ShareSwitchWithText = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;

  .switch {
    margin-top: -8px;
  }

  .text-container {
    margin-left: 8px;

    .title {
      margin-bottom: 4px;
    }

    .subtitle {
      font-size: 0.875rem;
      color: rgba(0, 0, 0, 0.6);
    }
  }
`;

// Estilos para ResultsModal
export const ResultsStatCard = styled.div`
  height: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
  padding: 24px;
  position: relative;
  background: white;

  .icon {
    color: #4285f4;
    margin-bottom: 8px;
  }

  .title {
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 8px;
  }

  .value {
    font-weight: bold;
    color: #333;
    font-size: 2rem;
  }

  .help-icon {
    position: absolute;
    bottom: 8px;
    right: 8px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #e0e0e0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    color: #999;
  }
`;

export const ResultsExportButton = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &.pdf {
    background-color: #dc3545;
    &:hover {
      background-color: #c82333;
    }
  }

  &.excel {
    background-color: #198754;
    &:hover {
      background-color: #157347;
    }
  }

  &.word {
    background-color: #0d6efd;
    &:hover {
      background-color: #0b5ed7;
    }
  }

  svg {
    font-size: 18px;
    color: white;
  }
`;

export const ResultsPaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;

  .left {
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.6);
  }

  .right {
    display: flex;
    align-items: center;
    gap: 16px;

    .info {
      font-size: 0.875rem;
      color: rgba(0, 0, 0, 0.6);
    }

    .buttons {
      display: flex;
      gap: 4px;

      button {
        padding: 4px 8px;
        border: none;
        background: none;
        cursor: pointer;
        font-size: 12px;

        &:disabled {
          color: rgba(0, 0, 0, 0.3);
          cursor: not-allowed;
        }
      }
    }
  }
`;

// Estilos para ImageOptionsModal
export const ImageOptionsModalPaper = {
  borderRadius: 2,
  minHeight: '200px',
};

export const ImageOptionsModalTitle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  pb: 1,
};

export const ImageOptionsModalContent = {
  pt: 1,
};

export const ImageOptionsModalStationName = {
  mb: 3,
};

export const ImageOptionsModalButtonsContainer = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
};

export const ImageOptionsModalVerButton = {
  justifyContent: 'flex-start',
  py: 1.5,
  textTransform: 'none',
  borderColor: '#2e7d32',
  color: '#2e7d32',
  '&:hover': {
    backgroundColor: '#e8f5e8',
    borderColor: '#1b5e20',
  },
};

export const ImageOptionsModalSubstituirButton = {
  justifyContent: 'flex-start',
  py: 1.5,
  textTransform: 'none',
  borderColor: '#1976d2',
  color: '#1976d2',
  '&:hover': {
    backgroundColor: '#e3f2fd',
    borderColor: '#1565c0',
  },
};

export const ImageOptionsModalRemoverButton = {
  justifyContent: 'flex-start',
  py: 1.5,
  textTransform: 'none',
  borderColor: '#d32f2f',
  color: '#d32f2f',
  '&:hover': {
    backgroundColor: '#ffebee',
    borderColor: '#c62828',
  },
};
